
import { RevCard } from '@ds/components/Card'
import { IconPlus } from '@ds/icons/IconPlus'

import BundleAddToCart from '../BundleAddToCart/BundleAddToCart.vue'
import BundleListing from '../BundleListing/BundleListing.vue'

export default {
  components: {
    BundleAddToCart,
    BundleListing,
    IconPlus,
    RevCard,
  },

  props: {
    status: {
      type: String,
      required: true,
    },
    listings: {
      type: Array,
      default: () => [],
    },

    totalPrice: {
      type: String,
      default: null,
    },
  },

  methods: {
    addToCart() {
      this.$emit('add-to-cart')
    },
  },
}
